import type { $Fetch } from 'ofetch';
import type {
  ForumTopico, UpsertForumTopicoCommand, ListForumTopicosParams,
  ForumResposta, CorrigirRespostaCommand,
} from '@/domain/model/Forum';
import type { ForumGateway } from '@/application/port/out/ForumGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const TOPICOS = '/api/v1/forum/topicos';

/** HTTP gateway do Fórum. Authorities `comunicacao:forum:read|manage`. */
export class HttpForumGateway implements ForumGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: ListForumTopicosParams): Promise<ForumTopico[]> {
    const params: Record<string, string> = {};
    if (p.disciplineId) params['disciplineId'] = p.disciplineId;
    if (p.status) params['status'] = p.status;
    const res = await this.client<ApiResponse<ForumTopico[]>>(TOPICOS, { method: 'GET', params });
    assertApiSuccess(res); return res.data;
  }
  async create(cmd: UpsertForumTopicoCommand): Promise<ForumTopico> {
    const res = await this.client<ApiResponse<ForumTopico>>(TOPICOS, { method: 'POST', body: cmd });
    assertApiSuccess(res); return res.data;
  }
  async update(id: string, cmd: UpsertForumTopicoCommand): Promise<ForumTopico> {
    const res = await this.client<ApiResponse<ForumTopico>>(`${TOPICOS}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res); return res.data;
  }
  async encerrar(id: string): Promise<ForumTopico> {
    const res = await this.client<ApiResponse<ForumTopico>>(`${TOPICOS}/${encodeURIComponent(id)}/encerrar`, { method: 'POST' });
    assertApiSuccess(res); return res.data;
  }
  async arquivar(id: string): Promise<void> {
    // 204 No Content — sem envelope.
    await this.client<void>(`${TOPICOS}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
  async listRespostas(topicoId: string): Promise<ForumResposta[]> {
    const res = await this.client<ApiResponse<ForumResposta[]>>(
      `${TOPICOS}/${encodeURIComponent(topicoId)}/respostas`, { method: 'GET' });
    assertApiSuccess(res); return res.data;
  }
  async corrigirResposta(respostaId: string, cmd: CorrigirRespostaCommand): Promise<ForumResposta> {
    // Backend aninha o corrigir sob /topicos: /api/v1/forum/topicos/respostas/{id}/corrigir
    const res = await this.client<ApiResponse<ForumResposta>>(
      `${TOPICOS}/respostas/${encodeURIComponent(respostaId)}/corrigir`, { method: 'POST', body: cmd });
    assertApiSuccess(res); return res.data;
  }
}
